<template>
  <div class="base-content">
    <form-frame
      :reset-visible="!isDetail"
      :submit-visible="!isDetail"
      @on-back="handleBack"
      @on-reset="handleReset"
      @on-submit="handleSubmit"
    >
      <div slot="content">
        <a-card title="次卡类型">
          <a-form-model
            ref="form"
            :model="form"
            :rules="rules"
            :label-col="{span:8}"
            :wrapper-col="{span:14}">
            <a-row>
              <a-col :span="10">
                <a-form-model-item label="次卡名称" prop="timesCardName">
                  <a-input v-model="form.timesCardName" :disabled="isDetail"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="10">
                <a-form-model-item label="次数：" prop="count">
                  <a-row :gutter="16">
                    <a-col :span="8">
                      <a-input-number style="width: 100%" size="large" v-model="form.count" :min="1" :max="9999999999" :disabled="isDetail"></a-input-number>
                    </a-col>
                    <a-col :span="2">次</a-col>
                  </a-row>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-card>
      </div>
    </form-frame>
  </div>
</template>

<script>
import { timesCardInfoById, timesCardSubmit } from '@/api/timesCard';
import FormFrame from '@/components/frame/FormFrame.vue';
import formMixin from '@/mixin/formMixin';

export default {
  name: 'timesCardForm',
  mixins: [formMixin],
  components: {
    FormFrame,
  },
  created() {
    if (this.paramsId) {
      this.getData(this.paramsId);
    }
  },
  data() {
    return {
      form: {
        timesCardName: '',
        count: 1,
      },
      rules: {
        timesCardName: [
          {
            required: true,
            message: '请输入次卡名称'
          }
        ],
        count: [
          {
            required: true,
            message: '请输入次数'
          }
        ],
      },
    };
  },
  methods: {
    // 信息
    getData(id) {
      timesCardInfoById(id).then((data) => {
        this.form = data;
      });
    },
    // 保存
    handleSave() {
      const params = { ...this.form };
      timesCardSubmit(params).then(() => {
        this.$message.success('操作成功！');
        this.handleBack();
      });
    },

    // 提交
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.handleSave();
        } else {
          this.$message.error('请按要求填写');
          return false;
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>

</style>
